import React from "react";

function Random() {
  return (
    <div id="random">
      <div className="random_container">
        <div className="box box_1">
          <h2>20% Off On Tank Tops</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores,
            facilis.
          </p>
          <button>SHOP NOW</button>
        </div>
        <div className="box box_2">
          <h2>Latest Eyewear For You</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores,
            facilis.
          </p>
          <button>SHOP NOW</button>
        </div>
        <div className="box box_3">
          <h2>Let's Suit Up</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores,
            facilis.
          </p>
          <button>SHOP NOW</button>
        </div>
      </div>
    </div>
  );
}

export default Random;
